import React from 'react';
import styled from '@mui/material/styles/styled';
import { Box } from '@mui/material';
import Typography from '../Typography';
var EmptyRoot = styled(Box)({
    textAlign: 'center'
});
var FbmEmpty = function (_a) {
    var desc = _a.desc, src = _a.src;
    return (React.createElement(EmptyRoot, null,
        React.createElement(Box, { src: src, component: 'img', sx: { width: '150px' } }),
        React.createElement(Typography, { color: 'secondary' }, desc)));
};
FbmEmpty.defaultProps = {
    desc: '',
    src: '//webcdn.fbmms.cn/web/saas/asset/image/CandidateInfoEmpty.png'
};
export default FbmEmpty;
